import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import google723582 from './google'
import phoneVerification316ed7 from './phone-verification'
import whatsappNotifications1cc057 from './whatsapp-notifications'
/**
* @see \App\Http\Controllers\Auth\SocialAuthController::google
* @see app/Http/Controllers/Auth/SocialAuthController.php:23
* @route '/auth/google'
*/
export const google = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: google.url(options),
    method: 'get',
})

google.definition = {
    methods: ["get","head"],
    url: '/auth/google',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\SocialAuthController::google
* @see app/Http/Controllers/Auth/SocialAuthController.php:23
* @route '/auth/google'
*/
google.url = (options?: RouteQueryOptions) => {
    return google.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\SocialAuthController::google
* @see app/Http/Controllers/Auth/SocialAuthController.php:23
* @route '/auth/google'
*/
google.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: google.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\SocialAuthController::google
* @see app/Http/Controllers/Auth/SocialAuthController.php:23
* @route '/auth/google'
*/
google.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: google.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\SocialAuthController::google
* @see app/Http/Controllers/Auth/SocialAuthController.php:23
* @route '/auth/google'
*/
const googleForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: google.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\SocialAuthController::google
* @see app/Http/Controllers/Auth/SocialAuthController.php:23
* @route '/auth/google'
*/
googleForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: google.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\SocialAuthController::google
* @see app/Http/Controllers/Auth/SocialAuthController.php:23
* @route '/auth/google'
*/
googleForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: google.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

google.form = googleForm

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::phoneVerification
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:42
* @route '/auth/phone-verification'
*/
export const phoneVerification = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: phoneVerification.url(options),
    method: 'get',
})

phoneVerification.definition = {
    methods: ["get","head"],
    url: '/auth/phone-verification',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::phoneVerification
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:42
* @route '/auth/phone-verification'
*/
phoneVerification.url = (options?: RouteQueryOptions) => {
    return phoneVerification.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::phoneVerification
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:42
* @route '/auth/phone-verification'
*/
phoneVerification.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: phoneVerification.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::phoneVerification
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:42
* @route '/auth/phone-verification'
*/
phoneVerification.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: phoneVerification.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::phoneVerification
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:42
* @route '/auth/phone-verification'
*/
const phoneVerificationForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: phoneVerification.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::phoneVerification
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:42
* @route '/auth/phone-verification'
*/
phoneVerificationForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: phoneVerification.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::phoneVerification
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:42
* @route '/auth/phone-verification'
*/
phoneVerificationForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: phoneVerification.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

phoneVerification.form = phoneVerificationForm

/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::whatsappNotifications
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:15
* @route '/auth/whatsapp-notifications'
*/
export const whatsappNotifications = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: whatsappNotifications.url(options),
    method: 'get',
})

whatsappNotifications.definition = {
    methods: ["get","head"],
    url: '/auth/whatsapp-notifications',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::whatsappNotifications
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:15
* @route '/auth/whatsapp-notifications'
*/
whatsappNotifications.url = (options?: RouteQueryOptions) => {
    return whatsappNotifications.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::whatsappNotifications
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:15
* @route '/auth/whatsapp-notifications'
*/
whatsappNotifications.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: whatsappNotifications.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::whatsappNotifications
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:15
* @route '/auth/whatsapp-notifications'
*/
whatsappNotifications.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: whatsappNotifications.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::whatsappNotifications
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:15
* @route '/auth/whatsapp-notifications'
*/
const whatsappNotificationsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: whatsappNotifications.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::whatsappNotifications
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:15
* @route '/auth/whatsapp-notifications'
*/
whatsappNotificationsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: whatsappNotifications.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\WhatsAppNotificationsController::whatsappNotifications
* @see app/Http/Controllers/Auth/WhatsAppNotificationsController.php:15
* @route '/auth/whatsapp-notifications'
*/
whatsappNotificationsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: whatsappNotifications.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

whatsappNotifications.form = whatsappNotificationsForm

const auth = {
    google: Object.assign(google, google723582),
    phoneVerification: Object.assign(phoneVerification, phoneVerification316ed7),
    whatsappNotifications: Object.assign(whatsappNotifications, whatsappNotifications1cc057),
}

export default auth